import { useTranslation } from 'react-i18next';

// Shown when the app can't bootstrap: an /api/me failure on a tenant portal host, or a
// tenantless host (signup/admin/sandbox) whose flags never resolved. Sign-in now lives on
// the Astro-served /login/ page, so a failed bootstrap no longer degrades to a brand-less
// SignIn form — it gets an explicit retry instead. Reuses SignIn.css (kept imported by
// App.jsx) for the centered card + alert styling.
export default function BootError({ onRetry }) {
  const { t } = useTranslation('common');
  return (
    <div className="signin-wrap">
      <div className="signin-card card">
        <div className="signin-body signin-boot-error">
          <div className="signin-alert" role="alert">{t('apiError.generic')}</div>
          <button className="btn btn-primary" onClick={onRetry}>{t('apiError.retry')}</button>
        </div>
      </div>
    </div>
  );
}
